/*
 * @Author: your name
 * @Date: 2022-01-28 15:32:26
 * @LastEditTime: 2024-11-21 21:09:22
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\filterField\BsyFilterText\index.jsx
 */

import React from 'react'
import { BsyUtils } from '../../../utils/Utils';
import BsyDeptCheckBox from '../../BsyDeptCheckBox';
import BsyDeptCheckList from '../../BsyDeptCheckList';
import BsyFilterBase from '../BsyFilterBase';

import './index.css'
import { BsyConfig } from '../../../global/BsyConfig';

export class BsyFilterDeptGroup extends BsyFilterBase {
    constructor(props) {
        super({
            customCls: "fui_dash_dept_group",
            minRow: 12,
            onStopEdit: null,
            displayType: {
                list: "deptchecklist",
                box: "deptcheck"
            },
            ...props
        })

        this.dashText = null;
    }

 
    _getAvailableMethods = () => {
        return [BsyConfig().CONST.FILTER_METHOD.IN,
        BsyConfig().CONST.FILTER_METHOD.ALL,
        BsyConfig().CONST.FILTER_METHOD.EQ,
        BsyConfig().CONST.FILTER_METHOD.EP,
        BsyConfig().CONST.FILTER_METHOD.NEP]
    }
 
    getValue = () => {
  
        if (this.dashText) {
            let e = this.dashText.getValue()

            switch (this.method) {
                case BsyConfig().CONST.FILTER_METHOD.EQ:
                case BsyConfig().CONST.FILTER_METHOD.ALL:
                case BsyConfig().CONST.FILTER_METHOD.IN:
                    return e;
                default:
                    return null
            }

        }
        return null
    }

    getContext = (e) => {
        this.dashText = e;
    }

    renderCont = () => {
        let e = this
        let i = this.options;
        let c = this._getAsyncConfig();
        let val = this.getMiddleValue();
        switch (e.method) {
            case BsyConfig().CONST.FILTER_METHOD.EQ:
            case BsyConfig().CONST.FILTER_METHOD.ALL:
            case BsyConfig().CONST.FILTER_METHOD.IN:
                if (i.minRow > i.height) {
                    return <BsyDeptCheckBox
                        theme={this.props.theme}
                        key={"ddkeyc"+ new Date().getTime()}
                        multiSelect={true}
                        value={val}
                        textField={"name"} 
                        valueField= {"_id"}
                        hasParentsDept={!0}
                        hasSelectCurrent={!0}
                        dynamicType={'set'}
                        height={'34px'}
                        hasSelectEmpty={!0}
                        hasCurrentDept={(!BsyUtils.isObjectEmpty(i.defaultConfig)) ? i.defaultConfig.hasCurrentDept : !1}
                        hasCurrentParDept={(!BsyUtils.isObjectEmpty(i.defaultConfig)) ? i.defaultConfig.hasCurrentParDept : !1}
                        hasCurrentSubDept={(!BsyUtils.isObjectEmpty(i.defaultConfig)) ? i.defaultConfig.hasCurrentSubDept : !1}
                        departmentsUrl={"/data/member/departments"}
                        currentDepartmentsUrl={'/data/member/current_departments'}
                        onStopEdit={e1 => {
                            e.value = e.getValue()
                            BsyUtils.applyFunc(e, i.onStopEdit, [{
                                value: e.getValue(),
                                valueMode: e.valueMode,
                                method: e.method,
                            }, i], !1)
                        }}
                        getContext={this.getContext}
                        async={c}
                    />
                } else {
                    return <BsyDeptCheckList
                        theme={this.props.theme}
                        key={"ddkeyc"+ new Date().getTime()}
                        value={val}
                        textField={"name"} 
                        valueField= {"_id"}
                        hasParentsDept={!0}
                        hasSelectCurrent={!0}
                        dynamicType={'set'}
                        hasSelectEmpty={!0}
                        hasCurrentDept={(!BsyUtils.isObjectEmpty(i.defaultConfig)) ? i.defaultConfig.hasCurrentDept : !1}
                        hasCurrentParDept={(!BsyUtils.isObjectEmpty(i.defaultConfig)) ? i.defaultConfig.hasCurrentParDept : !1}
                        hasCurrentSubDept={(!BsyUtils.isObjectEmpty(i.defaultConfig)) ? i.defaultConfig.hasCurrentSubDept : !1}
                        departmentsUrl={"/data/member/departments"}
                        currentDepartmentsUrl={'/data/member/current_departments'}
                        onStopEdit={e1 => {
                            e.value = e.getValue()
                            BsyUtils.applyFunc(e, i.onStopEdit, [{
                                value: e.getValue(),
                                valueMode: e.valueMode,
                                method: e.method,
                            }, i], !1)
                        }}
                        getContext={this.getContext}
                        async={c}
                    >

                    </BsyDeptCheckList>
                }
      
            default:
                break;
        }


    }
    render() {
        return (<>
            {
                this.createTitleBar()
            }
            <div className='bsy-dash-cont' >
                {
                    this.renderCont()
                }
            </div>
        </>)
    }
}

